import { EditorPlatformLive } from "../editor/platform-live.ts";
import { Layer, type Scope } from "effect";
import { DiffEditorsLive } from "./diff-editor-service.ts";
import { DiffEditorIoLive } from "./diff-editor-live.ts";
import { ImmutableModelsRootLive } from "./root.ts";

export const DiffEditorsRootLive = (owner: Scope.Scope) => DiffEditorsLive(owner).pipe(
  Layer.provide(DiffEditorIoLive.pipe(Layer.provide(EditorPlatformLive))),
  Layer.provideMerge(ImmutableModelsRootLive(owner))
);
